import React from 'react';

class Loader extends React.Component {
  render() {
    return (
      <div className="container tx-center">
        <div className="ht-100p d-flex flex-column align-items-center justify-content-center">
          <div className={`spinner-border text-primary ${this.props.className}`} role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Loader;
